var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0","padding":"0","width":"101%","height":"100%"},attrs:{"id":"app"}},[_c('GifWall',{key:_vm.w+_vm.h,attrs:{"gifH":_vm.pxPerRow,"gifW":_vm.pxPerCol,"cols":_vm.cols,"rows":3}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }